export default "__VITE_ASSET__DGsXsAKU__"